import { Box, SidePanel } from "@wix/design-system";
import React, { useContext, useRef, useState } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { HTMLData_Source } from "./../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { useBiNext } from "./../../../_shared/bi-context-provider/bi-context-provider.js";
import { containsUrl } from "./../../../_shared/link/contains-url.js";
import { useNodeAttrs } from "./../../../_shared/use-node-attrs.js";
import { HTML_EDIT_MODAL_ID } from "./../../consts.js";
import { FooterActions, Panel, PanelHeader } from "./../../../ui-components/index.js";
import { EDIT_PANEL, EDIT_PANEL_FOOTER_ACTIONS } from "../../data-hooks.js";
import { AdsenseSourceInput } from "./AdsenseSourceInput.js";
import { HtmlSourceInput } from "./HtmlSourceInput.js";
const InsertModal = ({ nodeId, closeModal }) => {
  const { t } = useContext(RicosContext);
  const logBi = useBiNext({ pluginId: "html", modalId: HTML_EDIT_MODAL_ID, nodeId });
  const { patchPmNodeAttrs, pmNodeAttrs } = useNodeAttrs(nodeId, "HTML");
  const [htmlNodeAttrs, setHtmlNodeAttrs] = useState(
    pmNodeAttrs
  );
  const inputRef = useRef(null);
  const isAdsense = htmlNodeAttrs?.isAdsense ?? htmlNodeAttrs?.source === HTMLData_Source.ADSENSE;
  const HtmlComponent = isAdsense ? AdsenseSourceInput : HtmlSourceInput;
  return /* @__PURE__ */ React.createElement("div", { style: { minHeight: 446 } }, /* @__PURE__ */ React.createElement(Panel, { closeButtonProps: { onClick: closeModal }, dataHook: EDIT_PANEL }, /* @__PURE__ */ React.createElement(PanelHeader, { title: t("HtmlPlugin_Edit_Modal_Title") }), /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3" }, /* @__PURE__ */ React.createElement(
    HtmlComponent,
    {
      htmlNodeAttrs,
      onHtmlInputChange: (html) => {
        setHtmlNodeAttrs({ url: null, html });
      },
      onLinkInputChange: (url) => {
        setHtmlNodeAttrs({ url: url ?? null, html: null });
      },
      inputRef
    }
  )), /* @__PURE__ */ React.createElement(SidePanel.Footer, { showDivider: true }, /* @__PURE__ */ React.createElement(
    FooterActions,
    {
      onCancel: closeModal,
      onSave: () => {
        if (htmlNodeAttrs?.url && !containsUrl(htmlNodeAttrs.url)) {
          inputRef.current?.focus();
          return;
        }
        htmlNodeAttrs && patchPmNodeAttrs?.(htmlNodeAttrs);
        closeModal();
      },
      saveButtonLabel: t("HtmlEditPanel_Update"),
      dataHook: EDIT_PANEL_FOOTER_ACTIONS,
      logBi
    }
  ))));
};
export {
  InsertModal
};
//# sourceMappingURL=InsertModal.js.map
